export default __webpack_public_path__ + "static/pro@768-200a0db55b27dc99f8fcf1cc1ed7565f.webp";